import { createEntityAdapter, createSlice, EntityId } from '@reduxjs/toolkit';
import { RootState } from "../index";
import { fetchBundle, fetchBundles, updateBundle } from "../../actions/mine_craft/bundlesActions";

export interface BundleInterface {
  url: string;

  id: number,
  name: string,
  version: string | null,
  thumbnail_url: string | null,

  prod: boolean,
  notification: boolean,
  push_cert_url: string | undefined,
  created_at: string,
  updated_at: string
}

export interface initialInterface {
  error: string | null;
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  count: number;

  editId: EntityId | null;
  editError: string | null;
}

const initialState: initialInterface = {
  error: null,
  status: 'idle',
  count: 0,

  editId: null,
  editError: null
};

const adaptor = createEntityAdapter<BundleInterface>();

const slice = createSlice({
  name: 'bundles',
  initialState: adaptor.getInitialState(initialState),
  reducers: {
    setEditId: (state, action) => {
      state.editId    = action.payload;
      state.editError = initialState.editError;
    },
    setEditError: (state, action) => {
      state.editError = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // #index
      .addCase(fetchBundles.pending, (state, _action) => {
        state.status = 'loading'
      })
      .addCase(fetchBundles.fulfilled, (state, action) => {
        state.count = action.payload.count;
        state.entities = action.payload.bundles;
        state.ids = action.payload.ids;
        state.status = 'succeeded';
      })
      .addCase(fetchBundles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message || 'Unknown Error';
      })

      // #show
      .addCase(fetchBundle.fulfilled, (state, action) => {
        const bundle = Object.values(action.payload.bundle)[0];
        state.entities[bundle.id] = bundle;
      })

      // #update
      .addCase(updateBundle.fulfilled, (state, action) => {
        const bundle = Object.values(action.payload.bundle)[0];
        state.entities[bundle.id] = bundle;
      })
      .addCase(updateBundle.rejected, (state, action) => {
        const error = Array.isArray(action.payload) ? action.payload[0] : null;
        state.editError = error || action.error.message || 'Unknown Error';
      })
  }
});

const reducer = slice.reducer;
export default reducer;

export const {
  setEditId,
  setEditError
} = slice.actions;

export const {
  selectById: selectBundleById,
  selectIds: selectBundleIds,
  selectEntities: selectBundleEntities,
}  = adaptor.getSelectors<RootState>(state => state.mineCraft.bundles);
